import React, { useRef, useMemo, useEffect } from 'react'
import ImageList from './ImageList'
import { useLocation } from 'react-router-dom'
import { QUERY_KEY } from 'shared-ui/utils/constants'
import { useFetchCreatorEconomyList } from 'shared-ui/hooks'
import { useQueryClient } from '@tanstack/react-query'

const CreatorHomeImageListPage = () => {
  const location = useLocation()
  const loadMoreRef = useRef(null)

  const navigationState = location.state
  const initialContentId = navigationState?.id
  const parentLocation = navigationState?.parentLocation
  const fromNotYetPublished = navigationState?.fromNotYetPublished || false
  const isUGC = location?.state?.is_UGC_state
  const category = navigationState?.category

  const queryClient = useQueryClient()

  useEffect(() => {
  queryClient.invalidateQueries({
    queryKey: [QUERY_KEY.GET_CREATOR_ECONOMY_LIST],
    exact: false
  })
}, [location.key, queryClient])

  const queryParams = useMemo(() => {
    if (parentLocation.includes('/explore-gallery')) {
      return {
        genre: category,
        content_type: 'image'
      }
    }

    return {
      playlist: 'today-highlights'
    }
  }, [parentLocation])
  const {
    data: creatorEconomyData,
    isLoading: fetchCreatorLoading,
    isError,
    error: creatorEconomyDataError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useFetchCreatorEconomyList(queryParams, {
    enabled: !!queryParams,
     staleTime: 0,
  refetchOnMount: 'always'
  })

  const mapData = creatorEconomyData?.pages?.flatMap(
    (page) => {
      const pageData = page?.data?.data
      if (Array.isArray(pageData)) return pageData
      if (pageData && Array.isArray(pageData.templates)) return pageData.templates
      return []
    }
  ) || []

  return (
    <ImageList
      listData={mapData || []}
      initialContentId={initialContentId}
      parentLocation={parentLocation}
      fromNotYetPublished={fromNotYetPublished}
      isUGC={isUGC}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
      loadMoreRef={loadMoreRef}
      queryKey={QUERY_KEY.GET_CREATOR_ECONOMY_LIST}
      category={navigationState?.category || ''}
      initialLoading={fetchCreatorLoading}

    />
  )
}

export default CreatorHomeImageListPage
